define([
    "../hereMapsModule"
], function (hereMapsModule) {
    "use strict";

    hereMapsModule.service("hereMapsLocalization", [
        function () {

            return {
                getLocalization: getLocalization
            };

            function getLocalization(lg) {
                switch (lg) {
                    case "pt":
                        return "pt-BR";
                    case "en":
                        return "en-US";
                    case "es":
                        return "es-ES";
                }
            }
        }
    ]);
});